export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Are we in a peak period?',
      $formkit: 'radio',
      if: '$incidentForms.type === Data',
      name: 'dataPeakPeriod',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Has there been an external incident identified to us from a provider?',
      $formkit: 'radio',
      if: '$incidentForms.dataPeakPeriod === no || $incidentForms.dataPeakPeriod === yes',
      name: 'externalIncidentIdentified',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Is Snowflake unavailable?',
      $formkit: 'radio',
      name: 'snowflakeDown',
      if: '$incidentForms.externalIncidentIdentified === no',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Have any ingestion tools suffered an outage for more than 12 hours?',
      $formkit: 'radio',
      help: 'e.g Kleene, Fivetran',
      if: '$incidentForms.snowflakeDown === no',
      name: 'ingestionToolingOutage',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Have any data transformation tools suffered an outage for more than 12 hours?',
      $formkit: 'radio',
      help: 'e.g DBT, Google Sheets, 3rd party connectors',
      if: '$incidentForms.ingestionToolingOutage === no',
      name: 'dataTransformationToolingOutage',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Have there been any trading, Tableau or subscriptions reporting failures?',
      $formkit: 'radio',
      if: '$incidentForms.dataTransformationToolingOutage === no',
      name: 'reportingFailures',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      $el: 'div',
      if: '$incidentForms.reportingFailures === no',
      children: [
        {
          $el: 'section',
          attrs: {
            class: 'incident-details',
          },
          children: [
            {
              $el: 'h3',
              children: 'We believe that this is a low severity incident.',
            },
            {
              $el: 'p',
              children: [
                'Contact the ',
                {
                  $el: 'a',
                  attrs: {
                    href: 'https://app.slack.com/client/TMVMM4ML5/CSQFLAJ76/',
                  },
                  children: 'data platform team',
                },
                ' for help.',
              ],
            },
          ],
        },
      ],
    },
  ],
}
